import React from 'react';
import { OutlinedInput, InputLabel, FormControl } from '@mui/material';

interface PhoneInputProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    sx?: any
}

const formatPhone = (value: string): string => {
    const numbers = value.replace(/\D/g, '').slice(0, 10);
    const parts = [];

    if (numbers.length > 0) parts.push(numbers.slice(0, 3));
    if (numbers.length >= 4) parts.push(numbers.slice(3, 6));
    if (numbers.length >= 7) parts.push(numbers.slice(6, 10));

    return parts.join('-');
};

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, label = "Teléfono", sx }) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input = e.target.value;
        const raw = input.replace(/\D/g, '').slice(0, 10); // solo dígitos
        onChange(raw); // enviamos el valor sin formato al padre
    };

    return (
        <FormControl fullWidth variant="outlined" sx={sx}>
            <InputLabel>{label}</InputLabel>
            <OutlinedInput
                value={formatPhone(value)} // se muestra con formato
                onChange={handleInputChange}
                label={label}
                inputProps={{ maxLength: 12 }}
            />
        </FormControl>
    );
};

export default PhoneInput;